import { useEffect, useState } from "react";
import { siteApi } from "../api";
import { PageHero, ServiceCard, Empty } from "./parts";
import { BookingButton } from "./Booking";

export default function ServicesPage() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState("all");
  useEffect(() => { siteApi.get("/website/services").then((r) => setData(r.data)).catch(() => setData({ categories: [], services: [] })); }, []);

  const cats = data?.categories || [];
  const services = data?.services || [];
  const grouped = cats.map((c) => ({ ...c, items: services.filter((s) => s.category_id === c.id) })).filter((c) => c.items.length);
  const uncategorized = services.filter((s) => !cats.some((c) => c.id === s.category_id));
  if (uncategorized.length) grouped.push({ id: "none", name: "Weitere Leistungen", items: uncategorized });
  const visible = active === "all" ? grouped : grouped.filter((g) => g.id === active);

  return (
    <>
      <PageHero eyebrow="Leistungen" title="Unsere Dienstleistungen" text="Von klassischen Schnitten bis zu individuellen Farb- und Pflegebehandlungen." action={<BookingButton testid="services-booking-button" />} />
      <div className="max-w-6xl mx-auto px-5 py-12 sm:py-16">
        {grouped.length > 1 && (
          <div className="flex gap-2 overflow-x-auto vs-hide-scrollbar pb-2 mb-10" data-testid="service-filter">
            {[{ id: "all", name: "Alle" }, ...grouped].map((c) => (
              <button key={c.id} data-testid={`service-filter-${c.id}`} onClick={() => setActive(c.id)} className={`shrink-0 px-4 py-2 rounded-full text-sm border transition-colors ${active === c.id ? "bg-[var(--brand-primary)] text-white border-[var(--brand-primary)]" : "bg-white text-stone-700 border-stone-200 hover:border-[var(--brand-primary)]"}`}>{c.name}</button>
            ))}
          </div>
        )}
        {data && grouped.length === 0 && <Empty>Derzeit sind keine Leistungen veröffentlicht.</Empty>}
        <div className="space-y-16">
          {visible.map((g) => (
            <section key={g.id} data-testid={`service-group-${g.id}`}>
              <div className="flex items-end gap-4 mb-6">
                <h2 className="font-serif text-3xl text-stone-900">{g.name}</h2>
                <span className="h-px flex-1 bg-stone-200 mb-3" />
              </div>
              {g.description && <p className="text-stone-600 mb-6 max-w-2xl">{g.description}</p>}
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{g.items.map((s) => <ServiceCard key={s.id} s={s} compact />)}</div>
            </section>
          ))}
        </div>
      </div>
    </>
  );
}
